import { Controller } from "@hotwired/stimulus"

// The scope bar sits outside the turbo frame, so this link is not re-rendered
// when the range or project changes. The URL is, because the form advances —
// copy its search string so the file is exactly what the page is showing.
export default class extends Controller {
  applyScope() {
    const url = new URL(this.element.href, window.location.origin)
    url.search = window.location.search
    this.element.href = `${url.pathname}${url.search}`
  }
}
